module.exports = __webpack_public_path__ + "static/media/profileIcon.74e487e5.svg";